export const FORM_ID = {
  GP: 'FORM_BAF_GP',
  AU: 'FORM_BAF_AU',
};
export const CONFIRMATION_ID = {
  GP: 'CONFIRMATION_BAF_GP',
  AU: 'CONFIRMATION_BAF_AU',
};
export const CONFIRM_PATH = {
  dev: '/gp/baf/confirmacion/',
  qa: '/order/gp/baf/confirmacion/',
  prod: '/order/gp/baf/confirmacion/',
};
export const CONFIRM_PATH_AU = {
  dev: '/au/baf/confirmacion/',
  qa: '/order/au/baf/confirmacion/',
  prod: '/order/au/baf/confirmacion/',
};

export const URL_SEO = 'www.movistar.es/order/gp/baf';
export const PATH_NAME = {
  GP: '/order/gp/baf',
  AU: '/order/gp/baf',
};
export const NEXT_STEPS =
  'Te llamaremos en los próximos días para concertar una cita para la instalación.';

export const PHONE_900 = '900 110 619';
export const HOME_URL = 'https://www.movistar.es/internet/';

export const STUDENT_COOKIE = 'studentInfo';
export const TRANSACTION_TYPE = 'baf';
